// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3PXFP","additionalInfo":"AgreementModal_additionalInfo__103Wr"};